import React, { useState } from 'react';
import { product } from '../data/ebook';
import { legalDocuments, type LegalDocument } from '../data/legal';
import { LegalModal } from './LegalModal';
export function LegalFooter() {
  const [openDoc, setOpenDoc] = useState<LegalDocument | null>(null);
  return <footer className="bg-white px-5 py-16 sm:px-8" data-id="element-79" data-mp="218cudznmvehb">
      <div className="mx-auto w-full max-w-content" data-id="element-80" data-mp="216rz27thvrie">
        <div className="grid gap-10 border-b border-line pb-12 md:grid-cols-[1fr_1.6fr] md:gap-16" data-id="element-81" data-mp="2f7uo8tfsdhxj">
          <div data-id="element-82" data-mp="2a9b2at170656">
            <p className="font-display text-2xl text-ink" data-id="element-83" data-mp="2a9t3m42ppajy">{product.title}</p>
            <p className="mt-1 text-xs uppercase tracking-[0.18em] text-muted" data-id="element-84" data-mp="2oxnx3mojniy3">
              {product.edition}
            </p>
          </div>

          <div data-id="element-85" data-mp="2jzcoff9zjehg">
            <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-ink" data-id="element-86" data-mp="2jzmcuyfdtdl1">
              Aviso legal y descargo de responsabilidad
            </h2>
            <p className="mt-4 text-[13px] leading-relaxed text-muted" data-id="element-87" data-mp="2t0k9uwrekku4">
              Este producto tiene fines exclusivamente informativos y educativos. El contenido aquí
              presentado no sustituye el consejo, diagnóstico o tratamiento médico profesional.
              Siempre busque el consejo de su médico u otro proveedor de salud calificado antes de
              realizar cambios en su dieta o rutina de ejercicio. El autor y los editores no se
              hacen responsables del uso que se le dé a esta información. Los resultados varían
              según la persona; no se garantizan resultados específicos. Al leer este documento,
              usted asume la responsabilidad total de sus acciones y decisiones de salud.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-4 pt-8 text-xs text-muted sm:flex-row sm:items-center sm:justify-between" data-id="element-88" data-mp="2z9cwahut40bk">
          <p data-id="element-89" data-mp="349hf4ej6t74y">© 2024 {product.title}. Todos los derechos reservados.</p>
          <nav aria-label="Enlaces legales" className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-90" data-mp="3899qeyzytre0">
            {legalDocuments.map(doc => <button key={doc.id} type="button" onClick={() => setOpenDoc(doc)} className="text-left underline decoration-line underline-offset-4 transition-colors duration-150 ease-out hover:text-ink hover:decoration-sage" data-id="element-91" data-mp="195t30jo17c7a">
                {doc.title}
              </button>)}
            <a href="#faq" className="transition-colors duration-150 ease-out hover:text-ink" data-id="element-92" data-mp="1ruzp8go1alxu">
              Preguntas frecuentes
            </a>
            <a href="#precio" className="transition-colors duration-150 ease-out hover:text-ink" data-id="element-93" data-mp="1mw6g10fs5h3h">
              Comprar la guía
            </a>
          </nav>
        </div>
      </div>

      <LegalModal document={openDoc} onClose={() => setOpenDoc(null)} data-id="element-94" data-mp="1wv3z3nufsif3" />
    </footer>;
}